import React, { useState } from 'react'
import {  deleteTransaction, updateTransaction } from '../firebase-services/db-services'
import handleChange from '../Utils/HandleChange';
import { FormInput, FormRow, RadioButtonGroup } from './Controls/Input';
import Select from './Controls/Select';
import {  materialsList, unitList } from '../Data/Constants';
import GetTimeStamp, {  getInputDateString } from '../Utils/GetTimeStamp';
import { useDispatch, useSelector } from 'react-redux';
import { getTransactionsFetch } from '../Redux/slices/transactionState';
import {  toast } from 'react-toastify';
import { selectPartyList } from '../Redux/slices/partyState';
import { selectDriverList } from '../Redux/slices/driverState';
import ConfirmDIalouge from './ConfirmDIalouge';
import { selectVehicleList } from '../Redux/slices/vehicleState';
export default function UpdateTransactions({ formData,setFormData }) {
    const dispatch = useDispatch()
    const [showDialouge,setShowDialouge] = useState(false)
    const parties = useSelector(selectPartyList)
    const drivers = useSelector(selectDriverList)
    const vehicles = useSelector(selectVehicleList)
    const changeHandler = handleChange(formData, setFormData)
    const submitHandler = (e) => {
        console.log("Record Updated")

        e.preventDefault()
        const data ={...formData,date:GetTimeStamp(formData.date)} 
        if (!formData.docid) return alert("Record Not selected!")
        updateTransaction(formData.docid, data).then(res => {
            console.log("Record Updated")
            dispatch(getTransactionsFetch())
            toast.success("Record Updated Successfully")
        }).catch(e => {
            toast.error("Failed to Update Record")
            console.error(e)

        })
    }
    const deleteHandler = ()=>{
        deleteTransaction(formData.docid).then(res => {
            console.log("Record Deleted")
            dispatch(getTransactionsFetch())
            setShowDialouge(false)
            setFormData({docid:null})
            toast.success("Record Deleted Successfully")
        }).catch(e => {
            toast.error("Failed to Delete Record")
            console.error(e)

        })
    }
    const deleteDialougueHandler=(e)=>{
        e.preventDefault()
        setShowDialouge(true)
    }

    return (
            <div id='updateTransactionForm' className="bg-gray-100 p-8 rounded-md mx-auto my-36 w-full max-w-7xl">
                {showDialouge&&<ConfirmDIalouge message='Delete Record' desc="Are you sure want to delete this record" action='Confirm' actionHandler={deleteHandler} closeHandler={()=>setShowDialouge(false)} />}
                <form className='w-full'>
                    <h1 className='text-2xl sm:text-3xl md:text-4xl font-bold tracking-wide mb-7'>Update Record</h1>
                    <FormRow mx={3}>
                        <FormInput name='date' type="datetime-local" label='Date' onChange={changeHandler} value={getInputDateString(formData.date)} />
                        <Select name='party_name' type='text' label='Party Name' placeholder='Party Name' options={parties} onChange={changeHandler} value={formData.party_name} />
                    </FormRow>
                    <FormRow mx={3}>
                        <Select name='material' label='Material' placeholder='Select Material' options={materialsList} onChange={changeHandler} value={formData.material} />
                        <FormInput name='quality' label='Material Quality' onChange={changeHandler} placeholder="Material Quality" value={formData.quality} />

                    </FormRow>
                    <FormRow mx={3}>
                        <FormInput name='quantity' min="0" type='number' placeholder='Quantity' label='Quantity' onChange={changeHandler} value={formData.quantity} />
                        <Select name='unit' label='Unit' options={unitList} placeholder="Select Unit" onChange={changeHandler} value={formData.unit} />
                    </FormRow>
                    <FormRow mx={3}>
                        <FormInput name='from' label='From' placeholder='From Location' onChange={changeHandler} value={formData.from} />
                        <FormInput name='to' type='text' label='To' placeholder='To Location' onChange={changeHandler} value={formData.to} />
                    </FormRow>
                    <FormRow mx={3}>
                        <FormInput name='supplier_name' label='Supplier Name' placeholder='Supplier Name' onChange={changeHandler} value={formData.supplier_name} />
                        <Select name='vehicle' type='text' label='Vehicle Name' placeholder='Select Vehicle Name' options={vehicles} onChange={changeHandler} value={formData.vehicle} />
                    </FormRow>
                    <FormRow mx={3}>
                        <Select name='driver' label='Driver Name' placeholder='Driver Name' options={drivers} onChange={changeHandler} value={formData.driver} />
                        <FormInput name='labour' type='text' label='Labour Name' placeholder='Labour Name' onChange={changeHandler} value={formData.labour} />
                    </FormRow>
                    <FormRow mx={3}>
                        <FormInput name='bill' type='number' min="0" label='Bill Amount' placeholder='Bill Amount' onChange={changeHandler} value={formData.bill} />
                        <FormInput name='paid' type='number' min="0" label='Bill Paid' placeholder='Bill Paid' onChange={changeHandler} value={formData.paid} />
                    </FormRow>
                    <RadioButtonGroup label='Payment type' name='payment_type' options={["Cash", "Credit"]} onChange={changeHandler} selected={formData.payment_type} />
                    <FormRow mx={3}>
                        <FormInput name='book_no' type='text' label='Book No' placeholder='Book No' onChange={changeHandler} value={formData.book_no} />
                        <FormInput name='slip_no' type='text' label='Slip No' placeholder='Slip No' onChange={changeHandler} value={formData.slip_no} />
                    </FormRow>
                    <FormRow mx={3}>
                        <FormInput name='party_sig' type='text' label='Party Sig' placeholder='Party Sig' onChange={changeHandler} value={formData.party_sig} />
                        <FormInput name='remark' type='text' label='Remarks' placeholder='Any Remarks' onChange={changeHandler} />
                    </FormRow>

                    <div className='flex flex-row gap-4'>
                        <button
                            className="hover:bg-[#4f48ee] rounded-md bg-[#6A64F1] py-3 px-8 text-center text-base font-semibold text-white outline-none"
                            onClick={submitHandler}
                        >
                            Submit
                        </button>
                        <button 
                            onClick={deleteDialougueHandler}
                            className="hover:bg-gray-600 cursor-pointer rounded-md bg-gray-500 py-3 px-8 text-center text-base font-semibold text-white outline-none"
                        >Delete Record</button>
                    </div>
                </form>
            </div>
    )
}